import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Diensten from "./sections/Diensten";
import DonkereCta from "./sections/DonkereCta";
import WaaromKiezenVoorEkonorm from "./sections/WaaromKiezenVoorEkonorm";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <Diensten />
      <DonkereCta />
      <WaaromKiezenVoorEkonorm />
      <Footer />
    </div>;
}